import { EvokeAction } from "react-evoke";
import { AppState } from "../../typings/AppState";
import { AppActions } from "../../typings/AppActions";
import { api } from "../../api";

const updateTerminals: EvokeAction<AppState, AppActions> = async (
  store,
  values: Array<string>,
  requestId: number,
  user: any
) => {
  try {
    let store_id = user.store_id;
    const updateTerminalAPIResponse = await api.patch(
      `stores/${store_id}/eod/${requestId}/defective`,
      {},
      { terminal_ids: values }
    );
    console.log(updateTerminalAPIResponse);
    await store.update((state) => {
      state.updateTerminalResponse = updateTerminalAPIResponse;
    });
  } catch (error) {
    console.log("error", error);
  }
};
const updateBusinessDayTableData: EvokeAction<AppState, AppActions> = async (
  user: any
) => {
  try {
    let store_id = user.store_id;
    await api.post(`stores/${store_id}/eod/business-day`, {}, {});
  } catch (error) {
    console.log("error", error);
  }
};
const getTerminals: EvokeAction<AppState, AppActions> = async (store) => {
  try {
    let userDetails = store.getState("auth");
    let store_id = userDetails.user.store_id;
    const terminals = await api.get(`stores/${store_id}/terminals`);
    // const terminalsObject = terminals.reduce(
    //   (acl: { [key: string]: any }, curr: { [key: string]: any }) => {
    //     acl[curr.id] = curr;
    //     return curr;
    //   },
    //   {}
    // );
    if(terminals.message==="You are not authorised for this action")
    {
      return terminals.message
    }
    else{
      await store.update((state) => {
        state.terminals = terminals;
      });
    }
   
  } catch (error) {
    console.log("error", error);
  }
};
const createTerminal: EvokeAction<AppState, AppActions> = async (
  store,
  values: object
) => {
  try {
    let userDetails = store.getState("auth");
    let storeId = userDetails.user.store_id;
    await api.post(
      `stores/${storeId}/terminals/`,
      {},
      values
    );

    // if (!createdTerminal.error) {
    //   await store.update((state) => {
    //     if (state.terminals !== undefined) {
    //       state.terminals[createdTerminal.id] = createdTerminal;
    //     }
    //   });
    // }
  } catch (error) {
    console.log("error", error);
    throw error;
  }
};

const updateTerminal: EvokeAction<AppState, AppActions> = async (
  store,
  id: number,
  values: object
) => {
  try {
    let userDetails = store.getState("auth", "user");
    let storeId = userDetails.store_id;
    await api.patch(
      `stores/${storeId}/terminals/${id}`,
      {},
      values
    );

    // await store.update((state) => {
    //   if (state.terminals !== undefined) {
    //     state.terminals[updateTerminal.id] = updateTerminal;
    //   }
    // });
  } catch (error) {
    console.log("error", error);
    throw error;
  }
};
const deleteTerminal: EvokeAction<AppState, AppActions> = async (
  store,
  id: number
) => {
  try {
    let userDetails = store.getState("auth");
    let store_id = userDetails.user.store_id;

    await api.delete(`stores/${store_id}/terminals/${id}`, {});
  } catch (error) {
    console.log("error", error);
  }
};
export const terminalActions = {
  updateTerminals,
  updateBusinessDayTableData,
  getTerminals,
  createTerminal,
  deleteTerminal,
  updateTerminal
};
